import React from 'react';

export const GlassPanel = React.forwardRef<
    HTMLDivElement,
    {
        children?: React.ReactNode;
        tone?: 'light' | 'dark';
        strength?: 'strong' | 'default' | 'soft' | 'thin';
        radius?: 'lg' | 'xl' | '2xl';
        blur?: 'sm' | 'md' | 'lg' | 'xl';
        className?: string;
    } & React.HTMLAttributes<HTMLDivElement>
>(function GlassPanel(
    { children, tone = 'light', strength = 'default', radius = 'xl', blur = 'lg', className = '', ...rest },
    ref,
) {
    const cls = [
        'ds-glass',
        tone === 'dark' ? 'ds-glass--dark' : '',
        strength !== 'default' ? `ds-glass--${strength}` : '',
        `ds-glass--r-${radius}`,
        blur !== 'lg' ? `ds-glass--blur-${blur}` : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (
        <div ref={ref} className={cls} {...rest}>
            {children}
        </div>
    );
});
